// extracted by mini-css-extract-plugin
module.exports = {"select":"select_select__6d7Sl"};